import { Component, OnInit,TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Router,ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactService } from './../../services/contact.service';
import { UserService } from './../../services/user.service';
import { SoaImageService } from './../../services/soa-image.service';
import { EncrDecrService } from '../../services/encr-decr.service';
import { CompanyService } from './../../services/company.service';

import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment.prod';
declare var $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-mobile-list',
  templateUrl: './mobile-list.component.html',
  styleUrls: ['./mobile-list.component.css']
})
export class MobileListComponent implements OnInit {
  modalRef: BsModalRef;
  config :any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true
  };

  user_id: any='';
  company_id: any='';
  APIKEY:any= '';
  customerList:object=[];
  customerModel:any = {};
  customerModel1:any = {};
  mobileFolderList:any=[];
  temp_var:any=false;
  delete_id:any='';
  emailModel:any={};
  loaderMode:any=false;
  folderid:any=0;
  currentUserRole:any='';
  abc:any=[];
  emailModal:any=true;
  emailModalError:any=false;
  noButtonTriggered = false;
  statusValue:string='all';
  on_date_time:any='';
  tableColumns:any=[];
  tableOrder:any=[];

  setFolderId:any=0;
  selectedUsers:any=[];

  assign_fact_check_css:any='block';

  submitted = false;

  private_id:any='';
  private_status:any='';


  filtter_soa_email:any='';
  filtter_factoring_id:any='';
  filtter_user_id:any='';
  filtter_customer_id:any='';
  filtter_additional_user_id:any='';

  soafiltter:object=[];
  userfiltter:object=[];
  customerfiltter:object=[];
  additionalUsersfiltter:object=[];

  

constructor(
  private http:HttpClient,
  private modalService: BsModalService,
  private _contact:ContactService,private _soaImage:SoaImageService,
  private _router : Router,
  private toastr: ToastrService,
  private _activatedroute: ActivatedRoute,
  private formBuilder: FormBuilder,
  private EncrDecr: EncrDecrService,
  private _company:CompanyService, 
  private _UserService:UserService,
  private SoaImageService: SoaImageService,) {}

  dtOptionsList: DataTables.Settings = {};

  ngOnInit() {
    this.user_id =localStorage.getItem('id');
    this.company_id =localStorage.getItem('company_id');
    this.APIKEY =localStorage.getItem('APIKEY');

    this.abc = localStorage.getItem('currentUser');
    var obj = JSON.parse(this.abc);

    this.currentUserRole = localStorage.getItem('role_name') ; //obj.role_name ;

    this.loaderMode=true;
    this.temp_var=true;
    // this.modalRef.open();
    //get customer for mobile and other role user
    const customerModal={
      APIKEY : this.APIKEY,
      user_id : this.user_id,
      company_id : this.company_id,
      status: 'active',
    }

    //this.diaplayDate();
    this.loadDatatable();
  
    // get mobile folder list  coode by dinesh
    this._soaImage.getMobileFiltterData(customerModal)
    .subscribe(
      res => {  
          this.soafiltter=res.data.soaImage;
          this.userfiltter=res.data.users;
          this.customerfiltter=res.data.customers;
          this.additionalUsersfiltter=res.data.additionalUsers;
          //console.log(this.additionalUsersfiltter);
     },
    );

    // end 
    this._UserService.getUserInfoForP(customerModal)
     .subscribe(
       res => {
           localStorage.setItem("role",res.data.role);  
           this.currentUserRole= res.data.role;
           //this.customerModel['customer']=0;
           //this.customerList=res;
         },
     );
     this._contact.getAssignContactListByid(customerModal)
     .subscribe(
       res => { 
          this.customerModel['customer']=0;
          this.customerList=res;
        //  this.loaderMode=false;
          
      //    this.temp_var=true;
     
       },
     );
     // end

  }

  onChangeSoaImage(value){
     this.filtter_soa_email= value;
     $('#dataTables_example').DataTable().draw();
  }

  onChangeFactoring(value){
     this.filtter_factoring_id= value;
     $('#dataTables_example').DataTable().draw();
  }
  onChangeUsers(value){
     this.filtter_user_id= value;
     $('#dataTables_example').DataTable().draw();
  }

  onChangeCustomers(value){
     this.filtter_customer_id= value;
     $('#dataTables_example').DataTable().draw();
  }
  onChangeAdditionalUsers(value){
     this.filtter_additional_user_id= value;
     $('#dataTables_example').DataTable().draw();
  }


  loadDatatable(){  this.loaderMode=false;
    if(this.currentUserRole == 'Mobile User'){
      this.tableColumns = [{ data: 'mobile_image_header.id' }, { data: 'action' }, { data: 'mobile_image_header.customer_name' }, { data: 'mobile_image_header.reference_number' }, { data: 'mobile_image_header.work_week' }, { data: 'mobile_image_header.load_number' }, { data: 'mobile_image_header.po_number' }, { data: 'mobile_image_header.created_at' }, { data: 'mobile_image_header.mobile_number' }] ;
      this.tableOrder = [[ 7, 'desc' ]] ;
    } else {
      this.tableColumns = [{ data: 'mobile_image_header.id' }, { data: 'action' }, { data: 'mobile_image_header.soa_email' }, { data: 'customer.assign_fact' }, { data: 'users.first_name' }, { data: 'mobile_image_header.customer_name' }, { data: 'additional_mob_users' },{ data: 'mobile_image_header.reference_number' }, { data: 'mobile_image_header.work_week' }, { data: 'mobile_image_header.load_number' }, { data: 'mobile_image_header.po_number' }, { data: 'mobile_image_header.mobile_invoice_number' }, { data: 'factoring_invoice_master.amount' }, { data: 'mobile_image_header.created_at' }, { data: 'mobile_image_header.mobile_number' }] ;
      this.tableOrder = [[ 13, 'desc' ]] ;
    }

    this.dtOptionsList = {
        pagingType: 'full_numbers',
        pageLength: 100,
        lengthMenu : [25, 50, 100, 150],
        columnDefs: [{
          'targets': [0,1], // column index (start from 0)
          'orderable': false, // set orderable false for selected columns
        }],
        order: this.tableOrder,
        serverSide: true,
        processing: true,
        ajax: (dataTablesParameters: any, callback) => {
          dataTablesParameters.minNumber = dataTablesParameters.start + 1;
          dataTablesParameters.maxNumber = dataTablesParameters.start + dataTablesParameters.length;

          dataTablesParameters.APIKEY = this.APIKEY;
          dataTablesParameters.user_id = this.user_id;
          dataTablesParameters.company_id = this.company_id;
          dataTablesParameters.status = 'active';

          dataTablesParameters.soa_email =this.filtter_soa_email;
          dataTablesParameters.factoring_id =this.filtter_factoring_id;
          dataTablesParameters.m_user_id =this.filtter_user_id;
          dataTablesParameters.customer_id =this.filtter_customer_id;
          dataTablesParameters.additional_user_id =this.filtter_additional_user_id;

          this.http
            .post<DataTablesResponse>(
              environment.api+'/SoaImage/getMobileFolderListAjax',
              dataTablesParameters
            )
            .subscribe((resp: any) => {
             // console.log('resp status' ,resp.status) ;
              this.loaderMode=false;
             //this.temp_var=true;

              if(resp.status==true){
                this.mobileFolderList=resp.data;
              }

              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
            });
        },
        columns: this.tableColumns
    };
  }
  
  diaplayDate(){
    const customerModal={
      APIKEY : this.APIKEY,
      user_id : this.user_id,
      company_id : this.company_id,
      status: 'active',
    }
    this._UserService.displayDate(customerModal)
    .subscribe(
      res => {
         //console.log(res); 
        },
    );
  }
  openModal(template: TemplateRef<any>) {
    $(function(){ 
      $(".select2").select2({
         placeholder: "--Select--"
      });
    });

    this.modalRef = this.modalService.show(template,this.config); 
    
  } 
 // manualentry
   
 getCustomerEmail(customer_id,filder_id){ this.assign_fact_check_css='block';
     this.emailModalError=false;
     this.loaderMode=true;
     this.folderid=filder_id;
      const folderModel={
        APIKEY : this.APIKEY,
        user_id : this.user_id,
        company_id : this.company_id,
        customer_id : customer_id,
      }
      
      this._contact.getContactEmailsByid(folderModel).subscribe(
        res => { 
             // console.log(res.data); 
             if(res.data.assign_fact=='3'){
               this.assign_fact_check_css='none';
             } 
             this.loaderMode=false;
             this.emailModel=res.data;
          },
      );
}


set_folder_id(fid){  
  this.setFolderId = fid; 
  //console.log('setFolderId ' , this.setFolderId) ;
}

set_user_id(uids){  
  //console.log('uids ' , uids) ;
  var userIds = uids.split(','); 
  //console.log('userIds ' , userIds) ;
  //console.log('userIds ' , userIds.length) ;

  for (var i = 0; i < userIds.length; i++) {
      this.selectedUsers.push({'id':userIds[i]}) ;
  }

  //console.log('selectedUsers ' , this.selectedUsers) ;
}

//send edit mobile link to all mobile users
send_sms_to_additional_user(){
    const data ={
      APIKEY:this.APIKEY,
      company_id:this.company_id,
      folderid:this.setFolderId,
      user_id:this.user_id,
      selectedUsers:JSON.stringify(this.selectedUsers),
      encrypted:this.EncrDecr.set(localStorage.getItem('key'), this.setFolderId)
    }

    //console.log('data sms ' , data);

    if(this.selectedUsers.length>0){
      this._UserService.sendSmsToAdditionalUser(data)
      .subscribe(
        res => {
          if(res.status==true){
            this.toastr.success(res.message, 'Success');
          } else {
            this.toastr.error(res.message, 'Error');
          }
        },
        err => console.log(err)
      );
    } else {
      this.toastr.error('User not selected', 'Error');
    }
    
  }

sendEmailToCust(){
  const folderModel={
    APIKEY : this.APIKEY,
    user_id : this.user_id,
    company_id : this.company_id,
    email_info : this.emailModel,
    folder_id:this.folderid
  }

  this._soaImage.sendEmailToCustomer(folderModel).subscribe(
    res => {  
        this.emailModal=false;

        this.modalRef.hide();

        if(res.status==true){
          this.toastr.success(res.message, 'Success');
        } else {
          this.toastr.error(res.message, 'Error');
        }
        
        this._router.navigateByUrl('/redirect').then(() => {
          this._router.navigateByUrl('/mobile/mobile-list');
        });
    },
  );

  /*if(this.emailModal){
    const rload=this;
    setTimeout(function(){  
      rload.emailModalError = true;
    }, 1000);
  }*/  
   
}


set_private_id(private_status, cid){
    this.private_id = cid;
    this.private_status = private_status;
  }


  onSubmitCustomer(){
    const a =  this.customerModel.customer;
    //console.log('aaaaaaa',a) ;

    const b = $(".select2").val();
    //console.log('bbbbbbb',b) ;
    if(b==''|| b==0){
      this.submitted = true;
      //console.log('submitted',this.submitted) ;
      return false ;
    }
    
    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), b); 

    //console.log(atob(a));
    this._router.navigateByUrl('/mobile/add-mobile/existing/'+encrypted);
    this.modalRef.hide();
  } 

  onSubmitCustomer1(){
    const a=  this.customerModel1.customer;
    this._router.navigateByUrl('/mobile/add-mobile/manually/'+a);
    this.modalRef.hide();
  } 


  set_delete_id(cid){
    this.delete_id = cid;
  }

  delete_user(){
    const data ={
      delete_id:this.delete_id,
      APIKEY:this.APIKEY,
      user_id:this.user_id,
    }
    //console.log(data); return false;
     
    this._soaImage.deleteMobileFolder(data)
      .subscribe(
        res => {
           this.toastr.success(res.message, 'Success');
           this._router.navigateByUrl('/redirect').then(() => {
              this._router.navigateByUrl('/mobile/mobile-list');
           });
        },
        err => console.log(err)
      );
  }
  redirectedinto(id)
  {
    
    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), id);  
    this._router.navigate(["/mobile/edit-mobile/"+encrypted]);
  
}
 
  redirected(id)
  {  
    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), id);  
    this._router.navigate(["/mobile/file-merge/"+encrypted]);
  }

  redirectedTo(id)
  {  
    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), id);  
    //this._router.navigate(["/mobile/factoring-invoice/"+encrypted]);
    this._router.navigate(["/factoring/factoring-tab1"]);
    //this._router.navigate(["/mobile/email-files-factoring/"+encrypted]);
    
  }

  // handleClick(event: Event) {
  //   console.log('Click!', event)
  // }

  makePrivate(p_status,id) { 
    const data ={
      mobile_id:id,
      p_status:p_status,
      APIKEY:this.APIKEY,
      user_id:this.user_id,
    }
   // console.log(data); return false;
     
    this._soaImage.updatePrivateStatus(data)
      .subscribe(
        res => {
          // console.log(res);
             this.toastr.success(res.message, 'Success');
           this._router.navigateByUrl('/redirect').then(() => {
              this._router.navigateByUrl('/mobile/mobile-list');
           });
         
        },
        err => console.log(err)
      );
      
   
  }

  privateUser(id): void {
      const data={
        mobile_id:id,
      APIKEY:this.APIKEY,
      user_id:this.user_id,
      }
      //console.log(data); 

      
    this._soaImage.SelectPrivateStatus(data)
    .subscribe(
      res => {
        //console.log(res); return false;
        if(res.p_status=='Yes'){
          confirm("You are not Authorized to Access this Page");
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/mobile/mobile-list');
         });
        }
         else this.redirectedinto(id);
      },
      err => console.log(err)
    );
   
  }


}
